import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import { AuthProvider } from './context/AuthContext';
import StripeWrapper from './components/StripeWrapper';

import ProtectedRoute from './routes/ProtectedRoute';

import Home from './pages/Home';
import Auth from './pages/Auth';
import VerifyRegister from './pages/VerifyRegister';
import VerifyLogin from './pages/VerifyLogin';
import Dashboard from './pages/Dashboard';
import Register from './pages/Register';
import Payment from './pages/Payment';
import Booking from './pages/Booking';
import Checkout from './pages/Checkout';
import Facility from './pages/Facility';
import Personal from './pages/Personal';
import OpenBays from './pages/OpenBays';

function App() {
  return (
    <>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
      </Helmet>
      <AuthProvider>
        <Routes>
          <Route index element={<Home />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/register" element={<Register />} />
          <Route path="/payment" element={
            <StripeWrapper>
              <Payment />
            </StripeWrapper>
          } />
          <Route path="/verify-register" element={<VerifyRegister />} />
          <Route path="/verify-login" element={<VerifyLogin />} />
          <Route path="/dashboard" element={<ProtectedRoute element={<Dashboard />} />} />
          <Route path="/booking" element={<ProtectedRoute element={<Booking />} />} />
          <Route path="/checkout" element={<ProtectedRoute element={<Checkout />} />} />
          <Route path="/facility" element={<ProtectedRoute element={<Facility />} />} />
          <Route path="/personal" element={<ProtectedRoute element={<Personal />} />} />
          <Route path="/open-bays" element={<ProtectedRoute element={<OpenBays />} />} />
        </Routes>
      </AuthProvider>
    </>
  );
}

export default App;